import React, { useState, useRef, useEffect } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { RootReducerState } from 'reduxStore/rootReducers';
import { NavLink } from 'react-router-dom';
import logo from 'assets/images/svg/logo.svg';
import { getNagivationMenu, getTopRightMenu, getRightButtonMenu, getSearchMenu, getFooterMenu, getBannerMenu, getBannerBySlug, searchContent } from 'reduxStore/actions';
import { storage, LOCALE, generateSlug, validURL, UrlFirstSegment, getFormData } from 'utils/global';
import { useHistory, useLocation } from 'react-router-dom';
import { setCurrentLocale } from 'reduxStore/actions/intlAction';
import { serviceType } from 'utils/constants';
import { FormattedMessage } from 'react-intl';
import { FiChevronDown, FiSearch } from 'react-icons/fi';
import { VscThreeBars } from 'react-icons/vsc';
import { IoMdClose } from 'react-icons/io';
import { FaPhoneAlt, FaViber } from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi';
import { loadable } from 'react-lazily/loadable';
const { TranslationMessage } = loadable(() => import('components'), {
	fallback: <>Loading...</>,
});
const { Image } = loadable(() => import('components'), {
	fallback: <>Loading...</>,
});

const Responsive = () => {
	const location = useLocation();
	const params = new URLSearchParams(window.location.search);
	const [searchText, setSearchText] = useState<any>(params.get('search_text') ?? '');

	const history = useHistory();
	const dispatch = useDispatch();
	const urlFirstSegment = UrlFirstSegment();

	// sidebar accordian
	const [autoHeight, setAutoHeight] = useState<any>({});

	const contentRef = useRef<any>();

	const lottieRef = useRef<any>(null);

	const handleClickAnimation = () => {
		if (lottieRef.current) {
			lottieRef.current.goToAndPlay(0, true);
		}
	};

	const [activeTopMenu, setActiveTopMenu] = useState<string>(location.pathname.split('/')[1] ?? serviceType.INDIVIDUAL);
	const [activeData, setActiveData] = useState<any>({});
	const [showSideBar, setShowSideBar] = useState<boolean>(false);

	const { locale, topMenuData, navigationMenuData, topRightMenuData, rightButtonMenuData, footerData, searchMenuData, error, loading, siteSettingData, contactSettingData } = useSelector(
		({ menuReducer, siteSettingReducer, contactSettingReducer, intl }: RootReducerState) => ({
			error: menuReducer.error,
			loading: menuReducer.loading,
			topMenuData: menuReducer.topMenuData,
			navigationMenuData: menuReducer.navigationMenuData,
			topRightMenuData: menuReducer.topRightMenuData,
			rightButtonMenuData: menuReducer.rightButtonMenuData,
			searchMenuData: menuReducer.searchMenuData,
			siteSettingData: siteSettingReducer.data,
			contactSettingData: contactSettingReducer.data?.[0],
			locale: intl.currentLocale,
			footerData: siteSettingReducer.data,
		}),
		shallowEqual
	);

	const handleSearch = (e) => {
		e.preventDefault();
		setShowSideBar(false);
		toggleNaviagtion('all');
		if (searchText) {
			dispatch(searchContent(getFormData({ parameter: searchText, section: '' })));
			setSearchText('');
			history.push(`search?search_text=${searchText}`);
		}
	};

	const handleLanguageChange = (lang: string) => {
		storage.set(LOCALE, lang);
		dispatch(setCurrentLocale(lang));
		toggleNaviagtion('languageDropdown');
	};

	const handleChange = (value: string) => {
		setActiveTopMenu(value);
		// dispatch(menuReset("all"));
		dispatch(getNagivationMenu(value));
		dispatch(getTopRightMenu(value));
		dispatch(getRightButtonMenu(value));
		dispatch(getSearchMenu(value));
		dispatch(getFooterMenu(value));
		dispatch(getBannerMenu(value));
		dispatch(getBannerBySlug(value));
	};

	const toggleNaviagtion = (name: string) => {
		const cloneData = activeData;
		const heightData = autoHeight;
		if (!cloneData.hasOwnProperty(name)) {
			cloneData[name] = false;
		}
		if (!heightData.hasOwnProperty(name)) {
			heightData[name] = '0px';
		}
		let data = Object.keys(cloneData).reduce((result, k) => {
			return { ...result, [k]: name === k && !cloneData[k] };
		}, {});

		const scrollHeight = contentRef.current && contentRef.current.scrollHeight;
		let height = Object.keys(heightData).reduce((result, k) => {
			return {
				...result,
				[k]: name === k ? (data[name] ? `${1000}px` : '0px') : '0px',
			};
		}, {});
		setAutoHeight(height);
		setActiveData(data);
	};

	const generateLink = (item) => {
		if (String(item.menu_url).includes('http'))
			return (
				<a href={item.menu_url} target="_blank">
					<TranslationMessage data={item} value="menu_title" />{' '}
				</a>
			);
		else
			return (
				<NavLink
					to={item.menu_url}
					activeClassName="active"
					onClick={() => {
						setShowSideBar(false);
						toggleNaviagtion('all');
					}}
				>
					<TranslationMessage data={item} value="menu_title" />
				</NavLink>
			);
	};

	return (
		<>
			{/* <NetworkStatus loading={loading} error={error} hasData={hasData} /> */}

			{/* sidemenu */}
			<header className="navbar border-bottom mob-header">
				<div className="container-fluid py-2 px-0">
					<div className="d-flex  w-100 align-items-center justify-content-between">
						<div className="navbar-header  ">
							<NavLink title="Home" to={`/`} className="logo navbar-btn pull-left">
								<Image className="img-fluid" src={footerData?.site_logo} alt="logo" onErrorSrc={logo} width="150" />
							</NavLink>
						</div>
						<div
							className="hambuger-menu text-right"
							onClick={() => {
								setSearchText('');
								setShowSideBar(true);
							}}
						>
							<div className="h4">
								<VscThreeBars className="text--danger" />
							</div>
						</div>
					</div>
				</div>
			</header>

			<div id="sidebar" className={`sidemenu ${showSideBar ? 'menu-opened' : 'menu-hide'}`}>
				{/* <div id="sidebar" className="sidemenu "> */}
				<header className="navbar border-bottom">
					<div className="container-fluid py-2 px-0">
						<div className="d-flex  w-100 align-items-center justify-content-between">
							<div className="navbar-header  ">
								<a className="logo navbar-btn pull-left" href="/" title="Home" rel="home">
									<Image className="img-fluid" src={footerData?.site_logo} alt="logo" onErrorSrc={logo} width="150" />
								</a>
							</div>
							<div className="hambuger-menu text-right" onClick={() => setShowSideBar(false)}>
								<div className="h4" id="sidebar-close-menu">
									<IoMdClose className="text-danger" />
								</div>
							</div>
						</div>
					</div>
				</header>

				<div className="sidebarmenu-wrapper">
					<form onSubmit={handleSearch}>
						<div className="sidebar-search-wrapper">
							<input type="text" value={searchText} placeholder="What are you looking for..." onChange={(e) => setSearchText(e.target.value)} />
							<FiSearch className="text-gray" onClick={handleSearch} />
						</div>
					</form>

					<ul className="listview primary-menu list-unstyled styled-list">
						{topMenuData.map((item, index) => {
							let slug = generateSlug(item.menu_title);
							if (slug === 'services-and-payments') slug = 'services-payments';
							return (
								item.hide_in_website === 'no' && (
									<li className="nav-item " key={index}>
										<div
											className={`nav-link ${activeTopMenu == slug ? 'active' : ''}`}
											onClick={() => {
												handleChange(slug);
												setShowSideBar(false);
												history.push(`/${slug}`);
											}}
										>
											<TranslationMessage data={item} value="menu_title" /> {/* <FiChevronRight /> */}
										</div>
									</li>
								)
							);
						})}
						<li className="nav-item ">
							<div>
								<a href="http://nbankhome.nabilbank.com/" className="nav-link">
									nBank
								</a>
							</div>
						</li>
					</ul>
					<ul className="listview secondary-menu  list-unstyled">
						{navigationMenuData.map((navigationItem, index) => {
							let navigationItemState = generateSlug(navigationItem.menu_title);
							return (
								navigationItem.hide_in_website === 'no' && (
									<li
										className={`nav-item has-dropdown ${activeData?.[navigationItemState] ? 'active-open' : ''}`}
										key={index}
										onClick={() => {
											toggleNaviagtion(navigationItemState);
										}}
									>
										<div className="nav-link">
											<TranslationMessage data={navigationItem} value="menu_title" />{' '}
										</div>

										<button className="lvl-toggle-btn">
											<FiChevronDown />
										</button>
										<ul className="inner-list opened-list list-unstyled" style={{ maxHeight: `${autoHeight[navigationItemState]}` }} ref={contentRef}>
											{navigationItem.submenu.map(
												(subNavigationItem, subNavigationItemIndex) =>
													subNavigationItem.hide_in_website === 'no' && (
														<React.Fragment key={subNavigationItemIndex}>
															<li className="inner-list-title" key={subNavigationItemIndex}>
																{/* <a href={void 0}>
															<TranslationMessage
																data={subNavigationItem}
																value="menu_title"
															/>{" "}
														</a> */}
																<NavLink
																	to={subNavigationItem.menu_url}
																	className="dropdown-link"
																	onClick={() => {
																		toggleNaviagtion('all');
																		setShowSideBar(false);
																	}}
																>
																	{/* <a className=" dropdown-link"> */}
																	<TranslationMessage data={subNavigationItem} value="menu_title" />
																	{/* </a> */}
																</NavLink>
															</li>

															{subNavigationItem.submenu.map(
																(subItem, subItemIndex) =>
																	subItem.hide_in_website === 'no' && (
																		<li className="inner-list-product" key={subItemIndex}>
																			{generateLink(subItem)}
																		</li>
																	)
															)}
														</React.Fragment>
													)
											)}
										</ul>
									</li>
								)
							);
						})}
					</ul>

					<ul className="listview tertary-menu list-unstyled tested">
						{[...topRightMenuData, ...rightButtonMenuData].map((menuItem, menuIndex) => {
							let menuItemState = generateSlug(menuItem.menu_title);
							return (
								menuItem.hide_in_website === 'no' &&
								menuItem.submenu.length > 0 && (
									<li className={`nav-item has-dropdown ${activeData?.[menuItemState] ? 'active-open' : ''}`} key={menuIndex} onClick={() => toggleNaviagtion(menuItemState)}>
										<a href={void 0} className="nav-link">
											<TranslationMessage data={menuItem} value="menu_title" />
										</a>
										<button className="lvl-toggle-btn">
											<FiChevronDown />
										</button>
										<ul
											className="inner-list list-unstyled opened-list pl-3"
											style={{
												maxHeight: `${autoHeight[menuItemState]}`,
												background: '#dbe2e6',
											}}
											ref={contentRef}
										>
											{menuItem.submenu.map(
												(submenuItem, smindex) =>
													submenuItem.hide_in_website === 'no' && (
														<li className="inner-list-product" key={smindex}>
															{generateLink(submenuItem)}
														</li>
													)
											)}
										</ul>
									</li>
								)
							);
						})}
						<li className={`nav-item has-dropdown ${activeData?.languageDropdown ? 'active-open' : ''}`}>
							<a
								href={void 0}
								onClick={(e) => {
									e.preventDefault();

									toggleNaviagtion('languageDropdown');
								}}
								className="nav-link"
							>
								{locale.toUpperCase()}
							</a>
							<button className="lvl-toggle-btn">
								<FiChevronDown />
							</button>
							<ul
								className="inner-list list-unstyled opened-list pl-3"
								ref={contentRef}
								style={{
									maxHeight: `${autoHeight.languageDropdown}`,
									background: '#dbe2e6',
								}}
							>
								<li
									className="inner-list-product"
									onClick={() => {
										setShowSideBar(false);
										handleLanguageChange('en');
									}}
								>
									<a href={void 0} role="button">
										<FormattedMessage id="language.english" />
									</a>
								</li>
								<li
									className="inner-list-product"
									onClick={() => {
										setShowSideBar(false);
										handleLanguageChange('ne');
									}}
								>
									<a href={void 0} role="button">
										<FormattedMessage id="language.nepali" />
									</a>
								</li>
							</ul>
						</li>
					</ul>
					<div className="contact-info contact-number">
						<label className="mb-2">Call</label>
						<a href={`tel:${contactSettingData?.address_section_phone_number}`} className="text-purple mb-2">
							<FaPhoneAlt className="text-danger mr-2" /> <span>{contactSettingData?.address_section_phone_number}</span>
						</a>
						<a href={`viber://chat?number=${siteSettingData?.viber}`} className="text-purple">
							<FaViber className="text-danger mr-2" /> <span>{siteSettingData?.viber}</span>
						</a>
						<a href={`tel:${contactSettingData?.ntc_toll_free_number}`} className="text-purple mb-2">
							<FaPhoneAlt className="text-danger mr-2" /> <span>{contactSettingData?.ntc_toll_free_number} (NTC Toll-Free)</span>
						</a>
						<a href={`tel:${contactSettingData?.ncell_toll_free_number}`} className="text-purple mb-2">
							<FaPhoneAlt className="text-danger mr-2" /> <span>{contactSettingData?.ncell_toll_free_number} (Ncell Toll-Free)</span>
						</a>
					</div>
					<div className="contact-info contact-number">
						<label className="mb-2">Email</label>
						<a href={`mailto:${contactSettingData?.address_section_email}`} className="text-purple mb-2 ">
							<HiOutlineMail className="text-danger mr-2" />
							<span>{contactSettingData?.address_section_email}</span>
						</a>
					</div>
				</div>
			</div>
		</>
	);
};

export default Responsive;
